import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-room-category-master',
  templateUrl: './room-category-master.component.html',
  styleUrls: ['./room-category-master.component.scss']
})
export class RoomCategoryMasterComponent implements OnInit {
  roomCategoryName: any;
  isActivevalue: any;
  roomCatId: any;
  enabledisablebtn: boolean = false;
  constructor(private authService: AuthService, private ipdService: IPDService, private exportdata: ExportService, private branchMasterService: BranchMatserService, public dashboardService: DashboardService,) {
    this.dashboardService.moudletype
      .subscribe((quote) => {
        if (quote == 1) {
          this.ngOnInit();
        }
      });
   }

  ngOnInit(): void {
    this.ClearData();
    this.getRoomCategoryMaster();
  }
  enableButton($event) {
    if (this.roomCategoryName == '') {
      this.enabledisablebtn = true;
    } else {
      this.enabledisablebtn = false;
    }
  }
  searchRecordModal() {
    document.getElementById("searchRecordModal").style.display = "block";
  }
  closeSearchRecordModal() {
    document.getElementById("searchRecordModal").style.display = "none";
  }
  categoryRoomArray: any = [];
  getRoomCategoryMaster() {
    this.roomCategoryName = '';
    this.isActivevalue = '';
    this.roomCatId = '';
    this.categoryRoomArray = [];
    this.ipdService.getRoomCategoryMaster(this.authService.Loggeduser.specialityId).subscribe((x: any) => {
      this.categoryRoomArray = x;
    });

  }
  checkChange(event) {
    this.isActivevalue = event.checked;
  }
  selectRow(id) {
    this.enabledisablebtn = false;
    this.roomCatId = id;
    var roomCategoryData = this.categoryRoomArray.filter(item => item.pK_RoomCategoryId == id);
    this.roomCategoryName = roomCategoryData[0]?.roomCategory;
    this.isActivevalue = roomCategoryData[0]?.isActive;
    document.getElementById("searchRecordModal").style.display = "none";
  }
  ClearData() {
    this.enabledisablebtn = true;
    this.roomCategoryName = '';
    this.isActivevalue = '';
  }
  saveroomCategoryMaster() {

    if (this.roomCatId > 0) {
      var roomCategoryData = this.categoryRoomArray.filter(item => item.pK_RoomCategoryId == this.roomCatId);

      let PayLoad = {
        "RoomCategoryMaster": {
          "pK_RoomCategoryId": this.roomCatId,
          "roomCategory": this.roomCategoryName,
          "isActive": this.isActivevalue ? true : false,
          "seqNo": roomCategoryData[0]?.seqNo,
          "Fk_SpecialityIdModule": this.authService.Loggeduser.specialityId,
          "isEdit": true,
          "isDelete": false
        }
      }

      this.branchMasterService.InsertRoomCategoryMaster(PayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.enabledisablebtn = true;
          this.dashboardService.openSnackBar("Record Updated Successfully ", "OK");
          this.getRoomCategoryMaster();
        }
      },
      err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
   
      }
    );
    } else {
      var roomCategoryData = this.categoryRoomArray.filter(item => item.roomCategory == this.roomCategoryName);

      if (roomCategoryData.length > 0) {
        this.dashboardService.openSnackBar("This RoomCategory Name already in list", "OK");
        this.roomCategoryName = '';
      } else {
        let PayLoad = {
          "RoomCategoryMaster": {

            "pK_RoomCategoryId": 0,

            "roomCategory": this.roomCategoryName,

            "isActive": this.isActivevalue ? true : false,
            
            "seqNo": this.categoryRoomArray.length + 1,
            "Fk_SpecialityIdModule": this.authService.Loggeduser.specialityId,
            "isEdit": false,

            "isDelete": false

          }
        }

        this.branchMasterService.InsertRoomCategoryMaster(PayLoad).subscribe(data => {
          if (data.statusCode == 1) {
            this.enabledisablebtn = true;
            this.dashboardService.openSnackBar("Record Saved Successfully ", "OK");
            this.getRoomCategoryMaster();

          } else if (data.statusCode == 10) {
            this.dashboardService.openSnackBar("Already Exists Description", "OK");
          } else {

            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        },
        err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
     
        }
      );
      }
    }

  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('showcontent');
    this.exportdata.Newexportxcel(element, 'RoomCategoryMaster');
  }
}
